import React from "react";
import Layout from "../hocs/Layout";
import {connect} from "react-redux";
import Section1 from "../components/download/section1";
import Section2 from "../components/download/section2";
import Section3 from "../components/download/section3";
import Question from "../components/download/question";
import Footer from "../components/navigation/Footer";
const Download = ({strellatv}) => {
    return (
        <Layout>
            {strellatv &&
                (
                    <>
                        <Section1/>
                        <Section2 data={strellatv} />
                        <Section3/>
                        <Question/>
                    </>
                )
            }

            <Footer/>
        </Layout>
    );
};


const mapStateToProps = state => ({
    strellatv: state.Home.strellatv,
})

export default connect(mapStateToProps, {})(Download)
